/* eslint-disable class-methods-use-this, no-new */
import { track } from "jiffy-analytics";
import EventClass from "common/utils/ui/event-class";

const getActiveCategory = $form =>
  $form.querySelector(".js-masthead-search-dropdown-button[data-active='true']")?.dataset.category;

class SearchBarForm extends EventClass {
  event(event, $form) {
    const formData = new FormData($form);
    const params = new URLSearchParams(formData);
    const searchURL = `${$form.action}?${params.toString()}`;

    track("search_button_clicked", {
      filter_category: getActiveCategory($form) || "none",
      search_term: formData.get("query"),
      search_url: searchURL
    });
  }
}

export default () => {
  new SearchBarForm({
    eventSelector: ".js-masthead-search-form",
    event: "submit"
  });
};
